export default "__VITE_ASSET__k14Fq9L4__"